/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationPipedriveSettingsPipelineStage = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The IntegrationPipedriveSettingsPipelineStage model module.
   * @module model/IntegrationPipedriveSettingsPipelineStage
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>IntegrationPipedriveSettingsPipelineStage</code>.
   * @alias module:model/IntegrationPipedriveSettingsPipelineStage
   * @class
   */
  var exports = function() {
    var _this = this;










  };

  /**
   * Constructs a <code>IntegrationPipedriveSettingsPipelineStage</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationPipedriveSettingsPipelineStage} obj Optional instance to populate.
   * @return {module:model/IntegrationPipedriveSettingsPipelineStage} The populated <code>IntegrationPipedriveSettingsPipelineStage</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PipeLineID')) {
        obj['PipeLineID'] = ApiClient.convertToType(data['PipeLineID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalStageID')) {
        obj['ExternalStageID'] = ApiClient.convertToType(data['ExternalStageID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ImportDealNames')) {
        obj['ImportDealNames'] = ApiClient.convertToType(data['ImportDealNames'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportDealCount')) {
        obj['ImportDealCount'] = ApiClient.convertToType(data['ImportDealCount'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportDealCountIndicatorID')) {
        obj['ImportDealCountIndicatorID'] = ApiClient.convertToType(data['ImportDealCountIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportDealSum')) {
        obj['ImportDealSum'] = ApiClient.convertToType(data['ImportDealSum'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportDealSumIndicatorID')) {
        obj['ImportDealSumIndicatorID'] = ApiClient.convertToType(data['ImportDealSumIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} PipeLineID
   * @default 0
   */
  exports.prototype['PipeLineID'] = 0;
  /**
   * @member {Integer} ExternalStageID
   * @default 0
   */
  exports.prototype['ExternalStageID'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Boolean} ImportDealNames
   */
  exports.prototype['ImportDealNames'] = undefined;
  /**
   * @member {Boolean} ImportDealCount
   */
  exports.prototype['ImportDealCount'] = undefined;
  /**
   * @member {Integer} ImportDealCountIndicatorID
   */
  exports.prototype['ImportDealCountIndicatorID'] = undefined;
  /**
   * @member {Boolean} ImportDealSum
   */
  exports.prototype['ImportDealSum'] = undefined;
  /**
   * @member {Integer} ImportDealSumIndicatorID
   */
  exports.prototype['ImportDealSumIndicatorID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


